var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Simulation',{attrs:{"simulationDevices":_vm.simulationDevices,"busConfigurations":_vm.busConfigurations,"simulationLabel":"TuxhornNemuxSMLV2_3d06_p20"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }